import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { RatingsSectionProps, RatingsData } from "./types";
import VoteBreakdownTooltip from "./tooltips/VoteBreakdownTooltip";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
interface ParticipationDropRatingsTotalSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
}
export default function ParticipationDropRatingsTotalSection(t0) {
  const $ = _c(27);
  const {
    drop,
    theme,
    ratingsData
  } = t0;
  const {
    currentRating
  } = ratingsData;
  const t1 = `tw-relative tw-inline-flex tw-items-baseline tw-gap-x-1 ${theme.indicator}`;
  const t2 = `tw-text-sm tw-font-semibold tw-text-iron-50 ${theme.text}`;
  const t3 = currentRating < 0 && "-";
  let t4;
  if ($[0] !== currentRating) {
    t4 = formatNumberWithCommas(Math.abs(currentRating));
    $[0] = currentRating;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = <span className={t2}>{t3}{t4}</span>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `total-rating-${drop.id}`;
  let t7;
  if ($[6] !== drop.wave.voting_credit_type || $[7] !== t6) {
    t7 = <span className="tw-text-sm tw-font-normal tw-text-iron-400 tw-cursor-help" data-tooltip-id={t6}>Total {drop.wave.voting_credit_type}</span>;
    $[6] = drop.wave.voting_credit_type;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `total-rating-${drop.id}`;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== drop || $[11] !== ratingsData) {
    t10 = <VoteBreakdownTooltip drop={drop} ratingsData={ratingsData} />;
    $[10] = drop;
    $[11] = ratingsData;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <Tooltip id={t8} style={t9}>{t10}</Tooltip>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t5 || $[18] !== t7) {
    t12 = <span>{t5}{" "}{t7}{t11}</span>;
    $[16] = t11;
    $[17] = t5;
    $[18] = t7;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== currentRating || $[21] !== drop.rating_prediction) {
    t13 = <DropVoteProgressing current={currentRating} projected={drop.rating_prediction} />;
    $[20] = currentRating;
    $[21] = drop.rating_prediction;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t1 || $[24] !== t12 || $[25] !== t13) {
    t14 = <div className="tw-flex tw-items-center tw-gap-x-1"><div className={t1}>{t12}{t13}</div></div>;
    $[23] = t1;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}